import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/performance')({
  component: () => <Outlet />,
  loader: () => ({
    crumb: 'Performance',
  }),
})
